/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import PropTypes from "prop-types";
import SearchIcon from "@material-ui/icons/Search";
import { Toolbar, Typography, InputAdornment, TextField } from "@material-ui/core";

import AzureGroupsDropdown from "./AzureGroupsDropdown";

const AzureContactsTableToolbar = ({ numSelected, groupsLookup, setSearchTerm, selectedGroups, setSelectedGroups }) => {
	return (
		<Toolbar className="d-flex justify-content-between">
			{numSelected > 0 ? (
				<Typography sx={{ flex: "1 1 100%" }} color="inherit" variant="subtitle1" component="div">
					{numSelected} selected
				</Typography>
			) : (
				<Typography sx={{ flex: "1 1 100%" }} variant="h6" id="tableTitle" component="div">
					Users preview
				</Typography>
			)}
			<div className="d-flex flex-row" style={{ rowGap: "3px" }}>
				<AzureGroupsDropdown items={groupsLookup} onChange={setSelectedGroups} selectedItems={selectedGroups} />
				<div style={{ width: 270 }} className="ml-4">
					<TextField
						onFocus={(e) => e.target.select()}
						autoComplete="off"
						fullWidth
						onChange={(event) => setSearchTerm(event.currentTarget.value)}
						placeholder="Search"
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon />
								</InputAdornment>
							),
						}}
					/>
				</div>
			</div>
		</Toolbar>
	);
};

AzureContactsTableToolbar.propTypes = {
	numSelected: PropTypes.number.isRequired,
};

export default AzureContactsTableToolbar;
